export class ProfessorModule {
    constructor(httpModule) {
        this.httpModule = httpModule;
    }
    async all() {
        const res = await this.httpModule.fetch("/professors");
        return res.json();
    }
    async get(id) {
        const res = await this.httpModule.fetch(`/professors/${id}`);
        return res.json();
    }
    async new(professor) {
        await this.httpModule.fetch("/professors", {
            method: "POST",
            body: JSON.stringify(professor),
        });
    }
}
//# sourceMappingURL=Professor.module.js.map